import { createApp } from 'vue';
import M4bToMp3Converter from '@/Components/M4bToMp3Converter.vue';
import '@styles/app.css';

createApp(M4bToMp3Converter).mount('#m4b-to-mp3-converter');
